import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../helpers/export'
import Service from '../../store/service'

export const getProvince = createAsyncThunk(
  'portfolioInsights/segment/portfolioProvince/getProvince',
  async (params, { rejectWithValue }) => {
    try {
      const response = await Service.getProvince(params)

      if (response.success) return response.data

      return rejectWithValue({ loading: false })
    } catch (error) {
      if (axios.isCancel(error)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const exportProvince = createAsyncThunk(
  'portfolioInsights/segment/portfolioProvince/exportProvince',
  async (params) => {
    const response = await Service.exportProvince(params)
    handleExport(response.data, response.filename)
  },
)
